// extracted by mini-css-extract-plugin
export default {"device-login-connect":"Pt70vk","deviceLoginConnect":"Pt70vk","connect-button":"_YYRj4","connectButton":"_YYRj4","codeInput":"fbn5_4"};